<template>
  <ul class="pa-park-note-list-view">
    <li v-for="note in noteList" :key="note.id">
      <ParkNoteItemBanner
       :parkNoteId="note.id"
       :link="true"
      />
    </li>
  </ul>
</template>

<script>
import ParkNoteItemBanner from '@/components/Parts/ParkNoteItemBanner/ParkNoteItemBanner.vue'

export default {
  props : {
    noteList : {
      default: () => {
        return [];
      }
    }
  },

  components : {
    ParkNoteItemBanner
  }
}
</script>

<style lang="scss">
.pa-park-note-list-view{
  li{
    margin-bottom:.5rem;
  }
}
</style>